export const TRANSLATIONS_FR = {
  sidebar: {
    hello: 'Bonjour',
    infoTime: "Temps pour terminer l'inscription",
    oop: "Plate-forme d'organisation d'intégration",
    business: {
      h2: "Informations sur l'entreprise",
      paragraph:
        "Dans ce domaine, vous devez nous donner plus d'informations sur l'organisation que vous allez intégrer.",
      dt1: "Nom de l'organisation légale dans le pays de l'opération",
      dd1: 'Tapez le nom légal qui a été enregistré dans le \n pays où vous opérez.',
      dt2: "Ville, adresse professionnelle et numéro de téléphone dans le pays de l'opération",
      dd2: "Fournissez les détails de l'adresse, la ville où l'organisation est située dans le pays où vous opérez et le numéro de téléphone utilisé au bureau.",
    },
    docs: {
      h2: 'Documentation demandée par \n UNHAS',
      paragraph:
        'Les documents suivants doivent être téléchargés, dûment complétés, signés par le Directeur/ Représentant de pays et téléversés dans le formulaire.',
      dt1: 'Formulaire d’introduction du signataire de l’organisation (lien)',
      dd1: 'Formulaire d’introduction à signer par le Directeur de pays',
      dt2: 'Conditions financières pour la prestation de services de transport aérien (lien)',
      dd2: 'Documentation nécessaire pour confirmer l’état de vos conditions financières.',
      dt3: 'Autres documents',
      dd3: 'Les autres documents doivent être téléversés s’ils sont indiqués dans le formulaire d’inscription.',
    },
    focalPoints: {
      h2: 'Coordonnées du Chef de l’Organisation et des Points Focaux.',
      paragraph:
        'Dans cette section, vous devez fournir les coordonnées du Chef de l’Organisation et des points focaux désignés, qui auront accès à des zones spécifiques sur le UN Booking Hub.​',
      dt1: 'Chef de l’Organisation/Représentant',
      dd1: 'Fournissez les coordonnées du Chef de l’Organisation/Représentant dans le pays d’opération.',
      dt2: 'Adjoint du Chef de l’Organisation',
      dd2: 'Responsable de : mises à jour du compte de l’organisation, vérification que les passagers réservés sont des employés, uniquement lors de la première réservation',
      dt3: 'Point Focal de Réservation',
      dd3: 'Fournissez les coordonnées des points focaux de réservation désignés, responsables\n' + 'des réservations de passagers.',
    },
    organisation: {
      h2: "Sélectionnez la catégorie \n d'organisation et le pays",
      paragraph:
        'Indiquez quelle catégorie représente le mieux votre \n organisation et le pays dans lequel vous opérez',
      dt1: "Catégorie d'organisation",
      dd1: 'Sélectionnez la catégorie qui décrit le mieux votre organisation',
      dt2: "Sélectionner l'opération de pays",
      dd2: 'Sélectionnez le pays pour lequel vous postulez',
    },
    review: {
      h2: 'Relecture finale',
      paragraph1: 'Vérifiez les informations avant de soumettre le formulaire.',
      h4: ' ',
      paragraph2: "Après la soumission, l’équipe UNHAS examinera votre demande et vous informera de l’état de votre candidature.",
    },
    submitted: {
      h2: 'Votre candidature a bien été reçue.',
      paragraph1: 'Un e-mail contenant toutes les informations pour les prochaines étapes a été envoyé à ',
      paragraph2: "L’équipe UNHAS examinera votre demande et vous informera de l’état de votre candidature.",
    },
    welcome: {
      h2: 'Bienvenue sur la Plateforme d’Intégration des Organisations',
      paragraph_1:
        'Cette plateforme est votre point de départ pour enregistrer votre organisation et obtenir l’accès aux services UNHAS.\n Veuillez vous assurer que toutes les informations requises sont prêtes avant de commencer',
      paragraph_2:
        'Le processus dure environ 15 minutes et doit être complété en une seule session — la progression ne peut pas être sauvegardée. Pour obtenir de l’aide, veuillez contacter le support UNHAS\n',
    },
    signUp: {
      intro: 'Services de réservation inter-agences disponibles 24/7 pour aider les travailleurs humanitaires à livrer l’aide jusqu’au dernier kilomètre',
      title: 'Enregistrez votre compte',
      description:
        '<0>Vous avez été invité à vous enregistrer par l’équipe de l’UNHAS. L’enregistrement vous permettra de commencer l’intégration de votre organisation dans le pays où vous opérez, afin de bénéficier du Service aérien humanitaire des Nations Unies.</0><1>Sachez qu’une fois connecté, le processus ne prendra pas plus de 15 minutes. Veuillez également vous assurer que vous disposez de tous les documents requis pour compléter le processus d’intégration en une seule fois. Il ne sera pas possible d’enregistrer et de continuer plus tard.</1>',
    },
    signIn: {
      intro: '24/7 inter-agency booking services supporting humanitarian workers to deliver last mile aid',
      title: 'Connectez-vous à votre compte',
      description:
        '<0>Connectez-vous pour commencer le processus d’inscription UNHAS de votre organisation. \\n</0><1>Le processus d’inscription dure environ 15 minutes. Veuillez vous assurer que vous disposez de tous les documents requis, car la progression ne peut pas être sauvegardée et doit être complétée en une seule session. </1>',
    },
  },
  content: {
    add: 'Ajouter',
    remove: 'Supprimer',
    email: 'E-mail',
    middleName: 'Deuxième nom',
    name: 'Nom',
    surname: 'Nom de famille',
    title: 'Titre/Désignation',
    phoneNumber: 'Numéro de téléphone',
    attachments: {
      maxSingleFileSize: 'Taille maximale par fichier',
      maxTotalFileSize: 'Taille totale maximale',
      allowedExtensions: 'Extensions autorisées'
    },
    business: {
      address: "Adresse professionnelle dans le pays de l'opération",
      btnBack: "Retour à l'organisation",
      btnSubmit: 'Aller à Directeur et points focaux',
      city: 'Ville',
      countryOperation: "Pays de l'opération",
      legalOrganisationName: "Nom de l'organisation légale dans le pays",
      organisationCategory: "Catégorie d'organisation demandeuse",
      stepper: "Informations sur l'entreprise",
    },
    docs: {
      docType1: "Formulaire d'introduction du signataire de l'organisation*",
      docType2: 'Conditions financières UNHAS pour la fourniture de services de transport aérien*',
      docType3: "Extra: Autorisation de l'institution gouvernementale*",
      docType4: "Extra: Lettre d'introduction de l'OCHA*",
      btnBack: 'Retour au directeur et aux points focaux',
      btnSubmit: 'Confirmer la demande',
      stepper: 'Documentation demandée par UNHAS',
    },
    focalPoints: {
      btnBack: 'De retour aux affaires',
      btnSubmit: 'Aller aux pièces jointes',
      booking: 'Point focal de réservation',
      clearing: 'Point focal de compensation',
      countryDirector: 'Chef de l’Organisation/Représentant',
      inTotal: 'au total',
      registering: 'Enregistrement du point focal',
      stepper: 'Informations du directeur et des points focaux',
      domainError: "Le domaine doit correspondre au domaine du RFP",
    },
    organisation: {
      category: "Catégorie d'organisation",
      country: "Pays de l'opération",
      h4: "N'oubliez pas d'avoir les informations suivantes pour \n procéder à la demande d'intégration de votre organisation:",
      li1: "Informations sur la catégorie d'organisation, le pays dans lequel vous \n opérez",
      li2: "Nom légal, adresse de l'organisation dans le pays où vous \n demandez l'intégration",
      li3: "Informations sur le directeur de pays, les points focaux d'enregistrement, \n de dédouanement et de réservation",
      li4: "Documents demandés par l'UNHAS",
      selectCategory: 'Sélectionnez la catégorie',
      selectCountry: 'Sélectionnez le pays',
      stepper: "Sélectionnez la catégorie d'organisation et le pays",
      submit: 'Confirmez et accédez au module de demande',
    },
    review: {
      btnBack: "Revenir à l'édition",
      btnSubmit: 'Soumettre',
      business: 'Entreprise',
      stepper: 'Soumettez votre demande si tout est correct',
    },
    welcome: {
      h2: 'Avant de Commencer',
      h4: "Pour poursuivre la demande d’intégration de votre organisation, veuillez vous assurer d’avoir les informations et documents suivants prêts :",
      li1: 'Nom légal de l’organisation et coordonnées dans le pays d’opération.',
      li2: 'Coordonnées du Chef de l’Organisation/Représentant',
      li3: 'Coordonnées de l’Adjoint du Chef de l’Organisation/Représentant',
      li4: 'Coordonnées des Points Focaux de Réservation désignés',
      li5: 'Documentation spécifiée dans le formulaire d’inscription, y compris',
      li5_1: 'Formulaire d’introduction du signataire de l’organisation dûment rempli et signé',
      li5_2: 'Conditions financières pour la prestation de services de transport aérien dûment remplies et signées',
      li5_3: 'Autres documents spécifiés dans le formulaire d’inscription',
      submit: 'Commencez maintenant le processus d’intégration',
    },
    signUp: {
      firstName: { title: 'Name', placeholder: 'Your name' },
      middleName: { title: 'Middle Name', placeholder: 'Your Middle name' },
      lastName: { title: 'Surname', placeholder: 'Your surname' },
      email: { title: 'Email', placeholder: 'Insert the email you want to use' },
      agency: { title: 'Agency', placeholder: 'Insert the agency you belong to' },
      password: { title: 'Password', placeholder: 'Insert the password (At least 6 characters)' },
      confirmPassword: { title: 'Repeat Password', placeholder: 'Repeat the password' },
      title: 'Register now',
      secure: 'Prove you are human, resolve this simple equation:',
      submit: 'Create your account and start the registration',
      or: 'Or',
      logIn: 'Log In now',
    },
    signIn: {
      email: { title: 'Email', placeholder: 'Insert the email shared with UNHAS' },
      password: { title: 'Password', placeholder: 'Insert the password' },
      title: 'Log In',
      intro: 'Please, insert the email communicated to UNHAS and the password you set during the registration',
      forgotPassword: 'Forgot the password?',
      submit: 'Log In now',
      or: 'Or',
      signUp: 'Register now to the UN Booking Hub',
    },
  },
};
